'use es6';

import Raven from 'Raven';
import { findDOMNode } from 'react-dom';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
import { getIframeModalHost } from 'ui-addon-upgrades/_core/utils/getIframeModalHost';
var upgradePointPromises = {};
export var upgradePointViews = {};
export function getApp() {
  return window.location.pathname.split('/')[1];
}
export function getScreen() {
  return window.location.pathname;
}
export function verifyMessage(ref, event) {
  return findDOMNode(ref.current).contentWindow === event.source;
}
export function matchMessage(event, message) {
  return event.data === message;
}

function getApiHost() {
  return enviro.isProd() ? 'api.hubspot.com' : 'api.hubspotqa.com';
}

export function createFrameSrc(_ref) {
  var upgradeKey = _ref.upgradeKey,
      app = _ref.app,
      screen = _ref.screen,
      host = _ref.host,
      portalId = _ref.portalId;
  return "https://" + host + "/ums-modal/" + portalId + "/" + upgradeKey + "?app=" + app + "&screen=" + screen;
}
export function getFrameSrc(upgradeKey) {
  return createFrameSrc({
    upgradeKey: upgradeKey,
    app: getApp(),
    screen: getScreen(),
    host: getIframeModalHost(),
    portalId: PortalIdParser.get()
  });
}

function fetchUpgradePoint(upgradeKey) {
  return http.get("https://" + getApiHost() + "/upgrade-management-service/v1/upgrade-configs/" + upgradeKey).catch(function (error) {
    var message = 'UpgradeManagement API Failure';
    Raven.captureMessage(message, {
      extra: {
        error: error
      }
    });
    return Promise.reject(new Error(message));
  });
}

export function delayUntilIdle(callback) {
  var delay = window.requestIdleCallback || window.setTimeout;
  var options = window.requestIdleCallback ? {
    timeout: 5000
  } : 5000;
  delay(callback, options);
}
export function getUpgradePointPromise(upgradeKey) {
  if (upgradePointPromises[upgradeKey]) {
    return upgradePointPromises[upgradeKey];
  }

  var upgradePointPromise = new Promise(function (resolve) {
    delayUntilIdle(function () {
      resolve(fetchUpgradePoint(upgradeKey));
    });
  });
  upgradePointPromises[upgradeKey] = upgradePointPromise;
  return upgradePointPromise;
}
export function getTrackingProperties(upgradePoint) {
  return Object.assign({}, upgradePoint, {
    app: getApp()
  });
}